import React, { useEffect } from "react";
import { Card, Descriptions, Empty, Spin } from "antd";
import { useApiWithFilters } from "../../../hooks/search/useApiWithFilters";
import { formatString } from "../../../utils/formatString";

interface Beneficiary {
  beneficiaryName?: string;
  beneficiaryAccountNumber?: string;
  beneficiaryIBAN?: string;
  beneficiaryBank?: string | { label: string; value: string };
  accountTitle?: string;
  iban?: string;
  accountNumber?: string;
  bank?: string;
  [key: string]: any;
}

interface BankAccountDetailsProps {
  ownerId?: string;
}

const BankAccountDetails: React.FC<BankAccountDetailsProps> = ({ ownerId }) => {
  const {
    data: result,
    loading: isLoading,

    fetchData,
  } = useApiWithFilters({
    apiUrl: `/property/beneficiary?ownerId=${ownerId}`,
    method: "GET",
  });

  useEffect(() => {
    if (ownerId) fetchData();
  }, [ownerId]);

  const beneficiaries = result?.result?.data || [];

  if (beneficiaries.length === 0) {
    return <Empty description="No bank account details found" />;
  }

  return (
    <div className="bank-account-card">
      {beneficiaries.map((item: Beneficiary, index: number) => (
        <Card key={beneficiaries?._id} loading={isLoading}>
          <Descriptions
            bordered
            size="middle"
            column={1}
            labelStyle={{
              fontWeight: 600,
              backgroundColor: "#f5f5f5",
              width: "30%",
            }}
            contentStyle={{ width: "70%" }}
          >
            <Descriptions.Item label="Beneficiary Name">{item.beneficiaryName || "-"}</Descriptions.Item>

            <Descriptions.Item label="Bank">
              {typeof item.beneficiaryBank === "object"
                ? item.beneficiaryBank.label
                : formatString(item.beneficiaryBank) || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Account Number">
              {item.beneficiaryAccountNumber || item.accountNumber || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="IBAN">{item.beneficiaryIBAN || item.iban || "-"}</Descriptions.Item>

            <Descriptions.Item label="Branch">{item.branch || "-"}</Descriptions.Item>

            <Descriptions.Item label="Address">{item.address || "-"}</Descriptions.Item>

            <Descriptions.Item label="Swift Code">{item.swiftCode || "-"}</Descriptions.Item>
          </Descriptions>
        </Card>
      ))}
    </div>
  );
};

export default BankAccountDetails;
